module.exports = __webpack_public_path__ + "static/hero-paper-center-3de8502e1894b360e176464e3e438b1c.webp";